export default __webpack_public_path__ + "static/media/ic-location.32410d6c.svg";